import { gettext } from '@adjust/dashboard-core/lib/utils/localization';

let filterConstants = {
  attributionSource: [
    {value: 'dynamic', label: gettext('label.dynamic')},
    {value: 'first', label: gettext('label.first')}
  ],
  conversionType: {
    dynamic: [
      {value: 'all', label: gettext('label.conversion-all')},
      {value: 'false', label: gettext('label.conversion-installed')},
      {value: 'true', label: gettext('label.conversion-reattributed')}
    ],
    first: [
      {value: 'all', label: gettext('label.conversion-all')},
      {value: 'false', label: gettext('label.conversion-installed')},
      {value: 'true', label: gettext('label.conversion-deattributed')}
    ]
  },
  impressionType: [
    {value: 'click', label: gettext('label.clicks')},
    {value: 'impression', label: gettext('label.impressions')},
    {value: 'all', label: gettext('label.all-engagements')}
  ],
  kpiBasis: [{
    name: gettext('label.users'),
    token: 'all',
    local: true
  }]
};

export { filterConstants };
